<template>
  <div>
    <div id="search">
      <el-row style=""><!--:default-time="['00:00:00', '23:59:59']"-->

       名称：<el-input v-model="title" size="mini" style="width: 120px"></el-input>
        付款时间：<el-date-picker
          style="width: 320px" size="mini"
          :default-time="['00:00:00', '23:59:59']"
          v-model="payTime"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right">
        </el-date-picker>

        <el-select v-model="orderField" size="mini" style="width: 100px" placeholder="请选择" >
          <el-option
            v-for="item in orderOpto"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="asc" size="mini" style="width: 70px" placeholder="请选择" >
          <el-option
            v-for="item in ascOpto"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>

        <el-select v-model="state" size="mini" style="width: 120px" placeholder="请选择" >
          <el-option
            v-for="item in stateOpto"
            :key="item.label"
            :label="item.label"
            :value="item.label">
          </el-option>
        </el-select>
        旗帜：<el-select v-model="checkedFlag" size="mini" multiple style="width: 200px" placeholder="请选择" >
          <el-option
            v-for="item in flagOpto"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>

            <!--<el-checkbox-group v-model="checkedFlag" @change="flagChange"  style="float:right;margin-right: 15px;">-->
              <!--<el-checkbox v-for="item in flagOpto" :label="item.value" :key="item.value" style="margin-left:0px; margin-right: 10px "><el-image :src="pic(item.value)" style=""></el-image> </el-checkbox>-->
            <!--</el-checkbox-group>-->

      </el-row>
      <el-row style="height: 40px; margin-top: 20px">
        <el-col>
          <el-button v-if="true" plain type="primary" size="mini" @click="export2Excel" style="margin-right: 20px">保存</el-button>
          <el-button type="primary" size="mini"  @click="insertBh" >重新生成</el-button>

          <el-checkbox size="mini" v-model="showImg" @change="chkImage" style="margin-left: 20px; margin-right: 4px">显示主图</el-checkbox>
          <el-checkbox size="mini" v-model="showTitle" @change="chkTitle" style="margin-left: 10px; margin-right: 4px">显示名称</el-checkbox>
          <el-checkbox v-model="span" style="margin-left: 10px; margin-right: 4px">合并名称</el-checkbox>
          <el-checkbox v-model="spanOuterId" @change="chkOuter" style="margin-left: 10px; margin-right: 30px">合并商家编码</el-checkbox>
          <el-checkbox v-model="onlyWaitSend"  style="margin-left: 10px; margin-right: 10px">只显示待发货订单</el-checkbox>
          <el-checkbox v-model="showRefund"  style="margin-left: 10px; margin-right: 10px">不显示退款订单</el-checkbox>

          <el-button type="primary" size="mini"  @click="insertBh" style="margin-left: 30px">搜索</el-button>

        </el-col>
      </el-row>
      <div class="block" align="center">
        <span class="demonstration"></span>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageObject.pageCurrent"
          :page-sizes="[50, 100, 500, 1000, 5000]"
          :page-size="pageObject.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageObject.rowCount">
        </el-pagination>
      </div>
    </div>

    <el-button type="primary" size="mini" @click="hide">全屏显示/恢复</el-button>


    <el-row>
      <el-col :span="24">
        <el-table border id="myTable"  style="font-size: 12px"  :data="bhData" :header-cell-style="{background:'#F2F6FC',color:'#000'}" :span-method="objectSpanMethod" :cell-style="{padding: '0px'}"><!--:span-method="objectSpanMethod"-->
          <el-table-column v-if="showImg" label="主图" width="80px">
            <template slot-scope="scope" >
              <img width="60px" height="60px" :src="scope.row.picUrl+'_100x100.jpg'" />
            </template>
          </el-table-column>
          <el-table-column v-if="showTitle" label="商品名称" >
            <template slot-scope="scope">
              {{scope.row.title}}<a :href="'https://detail.tmall.com/item.htm?id='+scope.row.numIid"
                                    target="_blank"
                                    class="primary">&#8194;详情</a>
            </template>
          </el-table-column>

          <el-table-column  prop="shortName" label="简称" width="120px"></el-table-column>
          <el-table-column  prop="outerSkuId" label="商家编码" width="160px"></el-table-column>
          <el-table-column  prop="skuShort" label="颜色分类" width="180px"></el-table-column>
          <el-table-column  prop="num" label="数量" width="80px"></el-table-column>
          <el-table-column  prop="totalNum" label="数量合计" width="80px"></el-table-column>
          <el-table-column  prop="orderPay" label="实付金额" width="80px"></el-table-column>
          <el-table-column  prop="totalOrderPay" label="金额合计" width="80px"></el-table-column>
          <el-table-column  prop="status" label="订单状态" width="120px"></el-table-column>
          <el-table-column  prop="refundStatus" label="退款状态" width="100px"></el-table-column>

        </el-table>
      </el-col>
    </el-row>


  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"

    export default {
        name: "BeiHuo",
      data(){
        return{
          display:1,
          deny:0,
          showImg:true,
          showTitle:true,
          span:true,
          spanOuterId:true,

          onlyWaitSend:false,
          showRefund:false,
          title:'',
          payTime:[],
          bhData:[],
          //合并列的序号
          idxs:[0,1,2,3,6,8],
          pageObject: {
            pageCurrent: 1,
            rowCount: 0,
            pageSize: 100
          },
          state:'',
          stateOpto:[{label:''},{label:'北京'},{label:'天津'},{label:'河北省'},{label:'山西省'},{label:'内蒙古自治区'},{label:'辽宁省'},{label:'吉林省'},{label:'黑龙江省'},{label:'上海'},
            {label:'江苏省'},{label:'浙江省'},{label:'安徽省'},{label:'福建省'},{label:'江西省'},{label:'山东省'},{label:'河南省'},{label:'湖北省'},
            {label:'湖南省'},{label:'广东省'},{label:'广西壮族自治区'},{label:'海南省'},{label:'重庆'},{label:'四川省'},{label:'贵州省'},{label:'云南省'},
            {label:'西藏自治区'},{label:'陕西省'},{label:'甘肃省'},{label:'青海省'},{label:'宁夏回族自治区'},{label:'新疆维吾尔自治区'}],
          orderField:'outer_sku_id',
          orderOpto:[{value:'title',label:'商品名称'}, {value:'outer_sku_id',label:'商家编码'}],
          asc:'asc',
          ascOpto:[{value:'asc',label:'正序'},{value:'desc',label:'倒序'}],
          sellerFlag: '',
          checkedFlag:[0,1,2,3,4,5],
          flagOpto:[{value:0,label:'灰'},{value:1,label:'红'},{value:2,label:'黄'},{value:3,label:'绿'},{value:4,label:'蓝'},{value:5,label:'紫'}],

          pickerOptions:{
            shortcuts: [{
              text: '今天',
              onClick(picker) {
                const end = new Date();

                let year2, month2, day2
                [year2, month2, day2] = [end.getFullYear(), end.getMonth(), end.getDate()]
                let start = new Date(year2, month2, day2, 0)
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
              }
            }]
          },
        }
      },
      methods:{
        flagChange:function(){
          console.log(this.checkedFlag);
          this.sellerFlag = '';
          for(i=0;i<this.checkedFlag.length;i++){
            this.sellerFlag += this.checkedFlag[i];
          }
          console.log(this.sellerFlag);
        },
        //返回备注旗帜名称
        pic:function(f){
          return './static/image/op_memo_' + f + '.png';
        },
        hide:function(){
          this.display++;
          if(this.display % 2 == 0){
            window.document.getElementById("left").style.display = 'none';
            window.document.getElementById("top").style.display = 'none';
            window.document.getElementById("search").style.display = 'none';
          }else {
            window.document.getElementById("left").style.display = 'block';
            window.document.getElementById("top").style.display = 'block';
            window.document.getElementById("search").style.display = 'block';
          }

        },
        idxPlus:function(){
          for(let i=0;i<this.idxs.length;i++){
              this.idxs[i] = this.idxs[i]+1;
              //if(this.idxs[i] == -1)
              //  this.idxs[i] = 0;
          }
        },
        idxPSub:function(){
          for(let i=0;i<this.idxs.length;i++){
              this.idxs[i] = this.idxs[i]-1;
            if(this.idxs[i] == -1)
              this.idxs[i] = 0;
          }
        },
        chkImage:function(){
          if(this.showImg){
            this.idxPlus();
            this.idxs.splice(0,0,0);
          }else{
            this.idxPSub();
            this.idxs.splice(0,1);
          }
          console.log(this.idxs);
        },
        chkTitle:function(){
          let index=0;
          if(this.showImg){
            index = 1;
          }
          if(this.showTitle){
            this.idxPlus();
            this.idxs.splice(index,0,1);
          }else{
            this.idxPSub();
            this.idxs.splice(index,1);
          }
          console.log(this.idxs)
        },
        chkOuter:function(){
          if(this.spanOuterId) {
            if (this.idxs.length == 5) {
              this.idxs.splice(3,0,3);
            }else if (this.idxs.length == 4) {
              this.idxs.splice(2,0,2);
            }else if (this.idxs.length == 3) {
              this.idxs.splice(1,0,1);
            }
          }else{
            if (this.idxs.length == 6) {
              this.idxs.splice(3,1);
            }else if (this.idxs.length == 5) {
              this.idxs.splice(2,1);
            }else if (this.idxs.length == 4) {
              this.idxs.splice(1,1);
            }
          }
          console.log(this.idxs);
        },
        export2Excel: function() {
          //导出只能导出加密的信息
          //this.getTradeData();
          // 设置当前日期
          let nick = storage.get("nick");
          let time = new Date();
          let year = time.getFullYear();
          let month = time.getMonth() + 1;
          let day = time.getDate();
          let name = nick +"_beihuo_"+ year + "" + month + "" + day;

          let tables = document.getElementById("myTable");
          let table_book = this.$XLSX.utils.table_to_book(tables);
          var table_write = this.$XLSX.write(table_book, {
            bookType: "xlsx",
            bookSST: true,
            type: "array"
          });
          try {
            this.$FileSaver.saveAs(
              new Blob([table_write], { type: "application/octet-stream" }), name+".xlsx");
          } catch (e) {
            if (typeof console !== "undefined") console.log(e, table_write);
          }
          this.isChecked = false;
          return table_write;
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
          if (this.span) { //this.title.length == 0
            //if ((columnIndex == 0) || (columnIndex == 1)|| (columnIndex == 5)|| (columnIndex == 7)) {
            if(this.idxs.indexOf(columnIndex)>=0){
              let rowcnt = row.rowCnt;
              let rownum = row.rowNum;

              let lpage = this.pageObject.pageCurrent;
              let lpagesize = this.pageObject.pageSize;
              let rspan=1;
              let cspan=1;
              //只要是第0行，不管序号是否为1
              if ((rowIndex == 0) || (rownum == 1)) {
                if (rowcnt - rownum + 1 > lpagesize - rowIndex) {
                  rspan = lpagesize - rowIndex;
                } else {
                  rspan = rowcnt - rownum + 1
                }
                cspan = 1;
              } else {
                rspan = 0;
                cspan = 0;
              }
              return {
                rowspan: rspan,
                colspan: cspan
              }
            }
          }
        },
        //改变pageSize
        handleSizeChange: function (val) {
          this.pageObject.pageSize = val;
          this.getBhData();
        },
        //当前页面改变
        handleCurrentChange: function (val) {
          this.pageObject.pageCurrent = val;
          this.getBhData();
        },
        getBhData:function () {
          let param={
            nick: storage.get("nick"),
            title:this.title,
            startDate:this.payTime[0],
            endDate: this.payTime[1],
            state: this.state,
            onlyWaitSend:this.onlyWaitSend,
            showRefund: this.showRefund,
            orderField: this.orderField,
            asc: this.asc,
            sellerFlag: this.checkedFlag,

            pageCurrent: this.pageObject.pageCurrent,
            rowCount: this.pageObject.rowCount,
            pageSize: this.pageObject.pageSize,
          }
          $api.post("/beihuo/get", param, response =>{
            let dataResult =  response.data;
            console.log(dataResult);
            if(dataResult.state == 1 && dataResult.message == "ok"){
              this.bhData = dataResult.data.beihuo;

              let pageObject = dataResult.data.pageObject;
              this.pageObject.rowCount = pageObject.rowCount;
              this.pageObject.pageSize = pageObject.pageSize;
            }else{
              this.$message.error(dataResult);
              this.deny = 1;
              this.$router.replace({name: "Index"});
            }

          })
        },
        insertBh:function () {
          if(this.deny == 1){
            this.$message.error("您没有该权限, 请联系主号分配权限。");
            return;
          }
          if(this.checkedFlag.length == 0){
            this.$message.error('旗帜不能为空，请选择旗帜颜色');
            return;
          }
          let param={
            nick: storage.get("nick"),
            title:this.title,
            startDate:this.payTime[0],
            endDate: this.payTime[1],
            state: this.state,
            onlyWaitSend:this.onlyWaitSend,
            showRefund: this.showRefund,
            orderField: this.orderField,
            asc: this.asc,
            sellerFlag: this.checkedFlag,
          }
          $api.post("/beihuo/insert", param, response =>{
            let dataResult =  response.data;
            console.log(dataResult);
            if(dataResult.state == 1 && dataResult.message == "ok"){
              this.getBhData();
              //this.$message.success("重新生成备货单完成！");
            }else{
              this.$message.error(dataResult);
              this.deny = 1;
              this.$router.replace({name: "Index"});
            }

          })
        },
      },
      mounted(){
        this.insertBh();
      }
    }
</script>

<style>

  .el-table .cell {
    white-space:normal;
    word-break:break-word;
    color: #000000;
  }

  a{
    color: #409EFF;
    text-decoration: none;
  }

</style>



// WEBPACK FOOTER //
// src/page/BeiHuo.vue